import React from 'react'
import ConfirmDialog from '../../../../../components/ConfirmDialog'

export const AvailableNowInfoModal: React.FC<{
  open: boolean;
  onClose: (dontShowAgain?: boolean) => void;
}> = ({ open, onClose }) => {
  const [dontShow, setDontShow] = React.useState<boolean>(false)
  return (
    <ConfirmDialog
      open={open}
      onClose={() => onClose(dontShow)}
      title={<b>Available Today?</b>}
      content={(
        <div style={{ fontSize: 14, color: 'var(--text-secondary, #666)' }}>
          <b>Priority Same‑Day Shift Alerts</b><br/><br/>
          Nicely done! While you have this switch turned ON, you will be the <b>first</b> to receive priority text messages for shifts posted today!<br/><br/>
          We'll automatically switch this OFF at the end of the day so you aren't getting unwanted text messages.<br/><br/>
          <a href="#" onClick={(e) => { e.preventDefault(); const url = 'https://support.tempstars.com/hc/en-us/articles/1500003613461-Available-Now-Switch'; try { if ((window as any).Cordova) { (window as any).cordova.InAppBrowser.open(url, '_system', 'location=yes'); } else { window.open(url, '_blank', 'location=yes'); } } catch {} }}>Learn more</a>
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
            <input id="availableNoShowReact" type="checkbox" checked={dontShow} onChange={(e) => setDontShow(e.target.checked)} />
            <label htmlFor="availableNoShowReact">Don't show this again</label>
          </div>
        </div>
      )}
      actions={[{ label: 'Got it!', variant: 'contained', onClick: () => onClose(dontShow) }]}
    />
  )
}

export const AvailableNowPenaltyModal: React.FC<{
  open: boolean;
  daysRemaining: number;
  onClose: () => void;
}> = ({ open, daysRemaining, onClose }) => (
  <ConfirmDialog
    open={open}
    onClose={onClose}
    title={<b>Cancellation Penalty in Effect</b>}
    content={(
      <div style={{ fontSize: 14, color: 'var(--text-secondary, #666)' }}>
        Due to previously cancelling a booking commitment, Available Shifts is blocked.<br/><br/>
        Days remaining: {daysRemaining}
      </div>
    )}
    actions={[{ label: 'OK', variant: 'contained', onClick: onClose }]}
  />
)

export const ShiftsTodayPromptModal: React.FC<{
  open: boolean;
  dateKey: string;
  onYes: () => void;
  onNo: () => void;
}> = ({ open, dateKey, onYes, onNo }) => (
  <ConfirmDialog
    open={open}
    onClose={onNo}
    title={<b>Shifts Available Right Now</b>}
    content={(
      <div style={{ fontSize: 14, color: 'var(--text-secondary, #666)' }}>
        There are shifts posted right now for today that are starting soon!<br/><br/>
        Would you like to see them for {dateKey}?
      </div>
    )}
    actions={[
      { label: 'No', onClick: onNo },
      { label: 'Yes', variant: 'contained', onClick: onYes }
    ]}
  />
)


